import { forwardRef, useState } from "react";
import { Input } from "./ui/input";
import { Eye, EyeOff } from "lucide-react";

const PasswordInput = forwardRef(function PasswordInput(
  { className = "", "data-testid": testId, ...props },
  ref,
) {
  const [show, setShow] = useState(false);
  const toggleId = testId ? `${testId}-toggle` : undefined;
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={show ? "text" : "password"}
        className={`pr-10 ${className}`}
        data-testid={testId}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-muted-foreground hover:text-foreground focus:outline-none"
        aria-label={show ? "Ocultar senha" : "Mostrar senha"}
        tabIndex={-1}
        data-testid={toggleId}
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});

export default PasswordInput;
